<template>
  <v-container>
    <v-row>
      <v-col class="pt-1 pb-0 px-5">
        <v-simple-table>
          <tbody>
            <tr v-for="(item, index) in details" :key="index">
              <td style="min-width: 230px; max-width: 230px; width: 230px; vertical-align: top; padding: 14px 16px">{{item.name}}</td>
              <td style="white-space: pre-wrap; padding: 14px 16px">{{item.value}}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";
  import _isNull from "lodash/isNull"
  import _isUndefined from "lodash/isUndefined"
  import _isArray from "lodash/isArray"
  import _join from "lodash/join"
  import _map from "lodash/map"
  import _isBoolean from "lodash/isBoolean"
  import {mapGetters} from "vuex";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "CompanyProfileDetails",
    props: {
      "company": {
        type: Object,
        required: true
      },
      "owner": {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      details () {
        const list = [
          { name: this.label("business"), value: this.company.business },
          { name: this.label("establishedYear"), value: this.company.establishedYear + " 年" },
          { name: this.label("representative"), value: this.company.representative },
          { name: this.label("numberOfEmployees"), value: this.toText(this.company.numberOfEmployees, this.consts.numberOfEmployees) },
          { name: this.label("netSales"), value: this.company.netSales },
          { name: this.label("zipCode"), value: this.company.zipCode },
          { name: this.label("prefecture"), value: this.toText(this.company.prefecture == null ? null : parseInt(this.company.prefecture), this.consts.prefectures) },
          { name: this.label("address"), value: this.company.address },
          { name: this.label("building"), value: this.company.building },
        ];
        return list;
      },
      toText () {
        return (value, items) => {
          if (_isNull(value) || _isUndefined(value) || _isNull(items) || _isUndefined(items)) {
            return ""
          }
          if (_isArray(value)) {
            return _join(_map(value, val => items.filter(item => item.value === val)[0].label), ", ")
          } else if (_isBoolean(value)) {
            return items.filter(item => item.value === (value ? 1 : 0))[0].label
          } else {
            return items.filter(item => item.value === value)[0].label
          }
        }
      },
      emailReceiveSettingText () {
        return this.profile.isReceiveMail ? this.label("receiveNews") : this.label("notReceiveNews")
      }
    },
    components: {}
  }
</script>
